import React, { useState } from 'react';
import { verifyOtp } from '../../Services/authService';
import { useNavigate } from 'react-router-dom';

const VerifyOtp = () => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const email = localStorage.getItem("otpEmail");

    const handleVerify = async (e) => {
    e.preventDefault();

    try {
        const payload = {
            id: 0,
            email: email,
            code: otp, // ✅ must be 'code' not 'otp'
            expiry: new Date().toISOString() // dummy (API requires it)
        };

        const res = await verifyOtp(payload);

        // 🔥 Handle response message
        if (res === "Invalid OTP" || res === "Invalid or Expired OTP") {
            setError(res);
            return;
        }

        if (res === "Account Activated" || res === "Account Activated Successfully") {
            alert("Account activated successfully");

            localStorage.removeItem("otpEmail");
            navigate('/login');
        } else {
            setError(res);
        }

    } catch (err) {
        console.error(err);
        setError("Verification failed");
    }
};

    return (
        <div className="auth-fluid">
            <div className="auth-fluid-form-box">
                <div className="card-body">

                    <h4>Verify OTP</h4>
                    <p>Enter OTP sent to your email</p>

                    {error && <p style={{ color: 'red' }}>{error}</p>}

                    <form onSubmit={handleVerify}>
                        <input className="form-control mb-3"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />

                        <button className="btn btn-success w-100" disabled={!otp}>
    Verify
</button>
                    </form>

                </div>
            </div>
        </div>
    );
};

export default VerifyOtp;